const SackDollar = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-sack-dollar"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-sack-dollar"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M13.088,5.084c1.065-.696,2.912-2.201,2.912-4.284V0H8V.8c0,2.083,1.847,3.588,2.912,4.284C5.548,5.908,1,12.63,1,18c0,3.309,2.691,6,6,6h10c3.309,0,6-2.691,6-6,0-5.37-4.548-12.092-9.912-12.916Zm-2.445,8.676l3.042,.507c1.341,.223,2.315,1.373,2.315,2.733,0,1.654-1.346,3-3,3v1h-2v-1c-1.654,0-3-1.346-3-3h2c0,.551,.449,1,1,1h2c.551,0,1-.449,1-1,0-.378-.271-.698-.644-.76l-3.042-.507c-1.341-.223-2.315-1.373-2.315-2.733,0-1.654,1.346-3,3-3v-1h2v1c1.654,0,3,1.346,3,3h-2c0-.551-.449-1-1-1h-2c-.551,0-1,.449-1,1,0,.378,.271,.698,.644,.76Z" />
    </svg>
  );
};

export default SackDollar;
